<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="1500px">
      <v-toolbar class="headline" color="primary" dark>{{ title }}</v-toolbar>
      <v-form ref="p1DialogForm" v-model="valid" lazy-validation>
        <v-card class="parkselect" outlined>
          <v-row>
            <v-col cols="5">
              <div class="parkbuken">物件グループ名</div>
              <ryou-select
                class="parkbukens"
                v-model="selectGroup"
                :value="selectGroup"
                :items="objectGroupItems"
                :itemText="'build_group_name'"
                :itemValue="'build_group_id'"
                :rules="objectBuildRules"
                :disabled="disGroup"
              >
              </ryou-select>
            </v-col>
            <v-col cols="1">
              <div class="parkriyo">利用者</div>
            </v-col>
            <v-col cols="3">
              <!--<ryou-select class="parkriyos" v-model="selectUser" :value="selectUser" :items="UserItems"
                           :itemText="'code_text'" :itemValue="'code_value'" :rules="UserIdRules">
              </ryou-select>-->
              <ryou-autocomplete
                class="parkriyos"
                v-model="selectUser"
                :value="selectUser"
                :items="UserItems"
                :itemText="'code_text'"
                :itemValue="'code_value'"
                :rules="UserIdRules"
              >
              </ryou-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-btn icon class="car" x-large>
              <v-icon medium>mdi-car</v-icon>
            </v-btn>
            <v-btn icon class="bicycle" x-large>
              <v-icon medium>mdi-bicycle</v-icon>
            </v-btn>
          </v-row>
        </v-card>
        <v-card class="parkdetails" outlined>
          <v-card-title style="padding-left: 0% !important">
            駐車場情報
          </v-card-title>
          <v-row style="height: 80px">
            <v-col cols="3">
              <ryou-select
                class="parkriyos"
                v-model="selectVehicleClass"
                :value="selectVehicleClass"
                :label="'車両区分名'"
                :items="vehicleClassItems"
                :itemText="'code_text'"
                :itemValue="'code_value'"
                :rules="vehicleClassRules"
                :disabled="disVehicleClass"
              >
              </ryou-select>
            </v-col>
            <v-col cols="3">
              <ryou-select
                class="parkriyos"
                v-model="selectvehicleId"
                :value="selectvehicleId"
                :label="'駐車番号'"
                :items="vehicleIdItems"
                :itemText="'code_text'"
                :itemValue="'code_value'"
                :rules="vehicleIdRules"
                :disabled="disVehicleId"
              >
              </ryou-select>
            </v-col>
          </v-row>
          <v-row style="height: 90px">
            <v-col cols="2">
              <ryou-input
                v-model="model.number_plate"
                :value="model.number_plate"
                :label="'ナンバープレート'"
                :rules="numberPlateRules"
                :maxlength="20"
              >
              </ryou-input>
            </v-col>
            <v-col cols="2">
              <ryou-input
                v-model="model.vehicle_name"
                :value="model.vehicle_name"
                :label="'車両名'"
                :maxlength="12"
              >
              </ryou-input>
            </v-col>
            <v-col cols="2">
              <ryou-date-format
                v-model="start_date"
                :value="start_date"
                :type="'date'"
                :format="'$1/$2/$3'"
                :rules="startDateRules"
                :label="'利用開始日'"
              >
              </ryou-date-format>
            </v-col>
            <v-col cols="2">
              <ryou-date-format
                v-model="end_date"
                :value="end_date"
                :type="'date'"
                :format="'$1/$2/$3'"
                :min="selectMin"
                :rules="endDateRules"
                :label="'利用終了日'"
              >
              </ryou-date-format>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ryou-textarea
                v-model="model.remark"
                :value="model.remark"
                :label="'特記事項'"
                :maxlength="128"
                :outlined="true"
              >
              </ryou-textarea>
            </v-col>
          </v-row>
          <ryou-confirm ref="confirm"></ryou-confirm>
          <v-row>
            <v-spacer></v-spacer>
            <ryou-black-btn
              :label="'閉じる'"
              :handlerClick="handleCancel"
              :iconCls="'mdi-close'"
            ></ryou-black-btn>
            <v-spacer></v-spacer>
            <ryou-black-btn
              :label="'登録'"
              :handlerClick="handleOk"
            ></ryou-black-btn>
            <v-spacer></v-spacer>
          </v-row>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>
<script>
import RyouInput from "@/components/formInput/RyouInput.vue";
import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";
import RyouSelect from "@/components/formInput/RyouSelect.vue";
import RyouTextarea from "@/components/formInput/RyouTextarea.vue";
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
import RyouConfirm from "@/components/dialog/RyouConfirm.vue";
import RyouAutocomplete from "@/components/formInput/RyouAutocomplete.vue";
export default {
  name: "ParkingInsertDialog",
  components: {
    RyouInput,
    RyouDateFormat,
    RyouSelect,
    RyouTextarea,
    RyouBlackBtn,
    RyouConfirm,
    RyouAutocomplete,
  },
  props: {
    url: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      dialog: false,
      title: "",
      disGroup: false,
      disVehicleClass: false,
      disVehicleId: false,
      // userDateUpdateFlg:false,
      valid: true,
      selectMin: "",
      input: "",
      selectGroup: "",
      selectUser: "",
      selectVehicleClass: "",
      selectvehicleId: "",
      start_date: "",
      end_date: "",
      objectGroupItems: [],
      UserItems: [],
      vehicleClassItems: [],
      vehicleIdItems: [],
      objectBuildRules: [],
      UserIdRules: [],
      numberPlateRules: [],
      vehicleClassRules: [],
      vehicleIdRules: [],
      startDateRules: [],
      endDateRules: [],
      model: {
        number_plate: "",
        vehicle_name: "",
        remark: "",
      },
    };
  },
  watch: {
    // 物件グループ選択
    selectGroup(value1) {
      if (value1 != null && value1 != "") {
        this.UsersList();
        //駐車番号
        let params = {
          build_group_id: value1,
          vehicle_class: this.selectVehicleClass,
        };
        this.getRequest(
          "/dormitoryParking/vehicleIdGet",
          params,
          this.$store.getters.getUserToken
        ).then((data) => {
          if (data.success) {
            if (data.result.length == 0) {
              this.vehicleIdItems = data.result;
              this.selectvehicleId = "";
              this.vehicleIdItems.push("");
            } else {
              this.vehicleIdItems = data.result;
            }
          }
        });
      } else {
        this.selectvehicleId = "";
      }
    },
    // 車両区分名選択
    selectVehicleClass(value2) {
      if (value2 != null && value2 != "") {
        //駐車番号
        let params = {
          build_group_id: this.selectGroup,
          vehicle_class: value2,
        };
        this.getRequest(
          "/dormitoryParking/vehicleIdGet",
          params,
          this.$store.getters.getUserToken
        ).then((data) => {
          if (data.success) {
            if (data.result.length == 0) {
              this.vehicleIdItems = data.result;
              this.selectvehicleId = "";
              this.vehicleIdItems.push("");
            } else {
              this.vehicleIdItems = data.result;
            }
          }
        });
      } else {
        this.selectvehicleId = "";
      }
    },
    start_date(value3) {
      if (value3 != null && value3 != "") {
        this.selectMin = value3;
      } else {
        this.selectMin = "";
      }
      let stDate = new Date(Date.parse(this.start_date.replace(/-/g, "/")));
      let enDate = new Date(Date.parse(this.end_date.replace(/-/g, "/")));
      if (stDate.getTime() > enDate.getTime()) {
        this.end_date = "";
      }
    },
  },
  methods: {
    add() {
      this.open();
      this.title = "駐車場登録";
      var record = null;
      this.buildGroupList(record);
      this.vehicleClassNameList();
      this.disGroup = false;
      this.disVehicleClass = false;
      this.disVehicleId = false;
      this.userDateUpdateFlg = false;
      this.requiredJudge();
    },
    edit(record) {
      this.open();
      this.title = "駐車場更新";
      this.buildGroupList(record);
      this.vehicleClassNameList();
      this.disGroup = true;
      this.disVehicleClass = true;
      this.disVehicleId = true;
      this.userDateUpdateFlg = true;
      this.requiredJudge();
    },
    requiredJudge() {
      if (this.userDateUpdateFlg == false) {
        //登録の場合チェック
        this.UserIdRules.push(this.GlobalRules.required);
        this.numberPlateRules.push(this.GlobalRules.required);
        this.startDateRules.push(this.GlobalRules.required);
        //this.endDateRules.push(this.GlobalRules.required);
        this.objectBuildRules.push(this.GlobalRules.required);
        this.vehicleClassRules.push(this.GlobalRules.required);
        this.vehicleIdRules.push(this.GlobalRules.required);
      } else {
        //更新の場合チェック
        this.UserIdRules.push(this.GlobalRules.required);
        this.numberPlateRules.push(this.GlobalRules.required);
        this.startDateRules.push(this.GlobalRules.required);
        //this.endDateRules.push(this.GlobalRules.required);
        this.objectBuildRules.splice(0);
        this.vehicleClassRules.splice(0);
        this.vehicleIdRules.splice(0);
      }
    },
    buildGroupList(record) {
      //物件グループ名
      var that = this;
      let params = {
        userId: this.$store.getters.getUserId,
        userClass: this.$store.getters.getUserClass,
      };
      this.getRequest(
        "/dormitoryParking/buildGroupGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          that.objectGroupItems = data.result;
          if (record != null) {
            that.selectGroup = record.build_group_id;
            that.selectVehicleClass = record.vehicle_class;
            that.selectvehicleId = record.vehicle_id_code;
            that.selectUser = record.user_id;
            that.model.number_plate = record.number_plate;
            that.model.vehicle_name = record.vehicle_name;
            that.model.remark = record.remark;
            let strDate = new Date(
              Date.parse(record.start_date.replace(/-/g, "/"))
            ); //转换成Data();
            var y = strDate.getFullYear();
            var m = strDate.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            var d = strDate.getDate();
            d = d < 10 ? "0" + d : d;
            that.start_date = y + "-" + m + "-" + d;
            if (record.end_date != "" && record.end_date != null) {
              let endDate = new Date(
                Date.parse(record.end_date.replace(/-/g, "/"))
              );
              var y1 = endDate.getFullYear();
              var m1 = endDate.getMonth() + 1;
              m1 = m1 < 10 ? "0" + m1 : m1;
              var d1 = endDate.getDate();
              d1 = d1 < 10 ? "0" + d1 : d1;
              that.end_date = y1 + "-" + m1 + "-" + d1;
            }
          }
        }
      });
    },
    vehicleClassNameList() {
      //車両区分名
      var that = this;
      let params = {
        userId: this.$store.getters.getUserId,
      };
      this.getRequest(
        "/dormitoryParking/vehicleClassNameGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          that.vehicleClassItems = data.result;
        }
      });
      setTimeout(() => {}, 100);
    },
    UsersList() {
      //利用者選択
      let params = {
        userId: this.$store.getters.getUserId,
        userClass: this.$store.getters.getUserClass,
        build_group_id: this.selectGroup,
      };
      this.getRequest(
        "/dormitoryParking/userListGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          var mapDatas = data.result.map((item) => {
            item.code_text =
              item.code_value + "　" + item.room_id + "　" + item.code_text;
            return item;
          });
          this.UserItems = mapDatas;
        }
      });
      setTimeout(() => {}, 100);
    },
    handleOk() {
      var valid = this.$refs.p1DialogForm.validate();
      if (valid) {
        var that = this;
        if (this.userDateUpdateFlg) {
          this.$refs.confirm
            .open("更新", "更新します。宜しいですか？", { color: "info" })
            .then((confirm) => {
              if (confirm) {
                let index = this.selectvehicleId.lastIndexOf("#");
                let params = {
                  loginUserId: this.$store.getters.getUserId,
                  build_group_id: this.selectGroup, //物件グループID
                  vehicle_class: this.selectVehicleClass, //車両区分
                  vehicle_id: this.selectvehicleId.substring(
                    index + 1,
                    this.selectvehicleId.length
                  ), //車両ID
                  user_id: this.selectUser, //ユーザID
                  number_plate: this.model.number_plate, //ナンバープレート
                  vehicle_name: this.model.vehicle_name, //車両名
                  start_date: this.start_date, //利用開始日
                  end_date: this.end_date != null ? this.end_date : "", //利用終了日
                  remark: this.model.remark, //特記事項
                };
                // 駐車場情報更新
                this.putRequest(
                  this.url.update,
                  params,
                  this.$store.getters.getUserToken
                ).then((resp) => {
                  if (resp.success) {
                    that.$emit("ok");
                    that.close();
                  }
                });
              }
            });
        } else {
          this.$refs.confirm
            .open("登録", "登録します。宜しいですか？", { color: "info" })
            .then((confirm) => {
              if (confirm) {
                let index = this.selectvehicleId.lastIndexOf("#");
                let params = {
                  loginUserId: this.$store.getters.getUserId,
                  build_group_id: this.selectGroup, //物件グループID
                  vehicle_class: this.selectVehicleClass, //車両区分
                  vehicle_id: this.selectvehicleId.substring(
                    index + 1,
                    this.selectvehicleId.length
                  ), //車両ID
                  user_id: this.selectUser, //ユーザID
                  number_plate: this.model.number_plate, //ナンバープレート
                  vehicle_name: this.model.vehicle_name, //車両名
                  start_date: this.start_date, //利用開始日
                  end_date: this.end_date != null ? this.end_date : "", //利用終了日
                  remark: this.model.remark, //特記事項
                };
                this.postRequest(
                  this.url.add,
                  params,
                  this.$store.getters.getUserToken
                ).then((resp) => {
                  if (resp.success) {
                    that.$emit("ok");
                    that.close();
                  }
                });
              }
            });
        }
      }
    },
    handleCancel() {
      this.close();
    },
    close() {
      this.dialog = false;
    },
    open() {
      this.vehicleIdItems.splice(0);
      this.selectvehicleId = "";
      this.UserItems.splice(0);
      this.end_date = "";
      this.start_date = "";
      this.dialog = true;
      if (this.$refs.p1DialogForm) {
        this.$refs.p1DialogForm.reset();
        this.$refs.p1DialogForm.resetValidation();
      }
    },
  },
};
</script>
<style scoped>
.parkselect {
  padding: 30px;
}

.parkdetails {
  padding: 30px;
}

.parkbuken {
  width: 130px;
  height: 60px;
  padding-top: 1.5%;
}

.parkbukens {
  width: 350px;
  height: 80px;
}

.parkbuken,
.parkbukens {
  float: left;
  box-sizing: border-box;
}

.parkriyo {
  padding-right: 3%;
  height: 60px;
  padding-top: 10%;
  text-align: right;
}

.parkriyos {
  height: 80px;
}
</style>
